import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { getPages } from 'component/pagination/utils'

import {
  FETCH_ADJUSTMENT_DONE_REQUEST,
  FETCH_ADJUSTMENT_DONE_SUCCESS,
  FETCH_ADJUSTMENT_DONE_ERROR,
} from 'actionTypes'

/*
 * REQUEST ADJUSTMENT_DONE
 */
export const fetch = (token, filters) => (dispatch) => {
  dispatch(fetchRequest())

  const params = {
    ...filters,
    hasPagination: true,
  }

  return new Api(token, dispatch)
    .post(API_URL.FETCH_ADJUSTMENT_DONE_FIND, params)
    .then(({ data: { pages, resultList } }) => {
      dispatch(getPages(pages))
      dispatch(fetchSuccess(resultList))
    })
    .catch((error) => {
      dispatch(fetchError(error))
    })
}

export const fetchRequest = () => ({
  type: FETCH_ADJUSTMENT_DONE_REQUEST,
})

export const fetchSuccess = (adjustmentDoneList) => {
  const adjustmentDoneListRevised = adjustmentDoneList.map((item) => ({
    ...item,
    manager:
      item.manager !== undefined ? `${item.manager} - ${item.nmApprover}` : '',
    c50Counted: item.c50Counted !== 0 ? item.c50Counted : '0',
    c50: item.c50 !== 0 ? item.c50 : '0',
    qtDifference: item.qtDifference !== 0 ? item.qtDifference : '0',
  }))
  return {
    type: FETCH_ADJUSTMENT_DONE_SUCCESS,
    payload: adjustmentDoneListRevised,
  }
}

export const fetchError = (error) => ({
  type: FETCH_ADJUSTMENT_DONE_ERROR,
  payload: error,
})
